import { getNamedType, GraphQLList } from 'graphql';
import { delegateToSchema } from '@graphql-tools/delegate';
import { batchDelegateToSchema } from '@graphql-tools/batch-delegate';
export function createMergedTypeResolver(mergedTypeResolverOptions) {
    const { fieldName, argsFromKeys, valuesFromResults, args } = mergedTypeResolverOptions;
    if (argsFromKeys != null) {
        return (originalResult, context, info, subschema, selectionSet, key) => {
            var _a;
            return batchDelegateToSchema({
                schema: subschema,
                operation: 'query',
                fieldName,
                returnType: new GraphQLList(getNamedType((_a = info.schema.getType(originalResult.__typename)) !== null && _a !== void 0 ? _a : info.returnType)),
                key,
                argsFromKeys,
                valuesFromResults,
                selectionSet,
                context,
                info,
                skipTypeMerging: true,
            });
        };
    }
    if (args != null) {
        return (originalResult, context, info, subschema, selectionSet) => {
            var _a;
            return delegateToSchema({
                schema: subschema,
                operation: 'query',
                fieldName,
                returnType: getNamedType((_a = info.schema.getType(originalResult.__typename)) !== null && _a !== void 0 ? _a : info.returnType),
                args: args(originalResult),
                selectionSet,
                context,
                info,
                skipTypeMerging: true,
            });
        };
    }
    return undefined;
}
//# sourceMappingURL=createMergedTypeResolver.js.map